import { looksLikeFortigate, parseFortigate } from './parser/fortigate'
import { audit } from './rules/engine'
import { FORTIGATE_RULES } from './rules/fortigate/index'
import { MESSY_CONFIG } from './rules/fortigate/fixtures'
import { renderAudit } from './ui/render'

const input = document.querySelector<HTMLTextAreaElement>('#config-input')!
const results = document.querySelector<HTMLElement>('#results')!
const status = document.querySelector<HTMLElement>('#status')!

document.querySelector('#audit-btn')!.addEventListener('click', () => runAudit())
document.querySelector('#clear-btn')!.addEventListener('click', () => {
  input.value = ''
  results.replaceChildren()
  status.textContent = ''
  input.focus()
})
document.querySelector('#example-btn')!.addEventListener('click', () => {
  input.value = MESSY_CONFIG
  runAudit()
})

// Ctrl/Cmd+Enter is what an engineer will try first in a textarea.
input.addEventListener('keydown', (event) => {
  if ((event.metaKey || event.ctrlKey) && event.key === 'Enter') {
    event.preventDefault()
    runAudit()
  }
})

// Auditing on paste is the whole point — one action, immediate answer, no signup wall.
input.addEventListener('paste', () => {
  setTimeout(() => runAudit(), 0)
})

function runAudit(): void {
  const text = input.value
  if (text.trim() === '') {
    results.replaceChildren()
    status.textContent = ''
    return
  }

  if (!looksLikeFortigate(text)) {
    results.replaceChildren()
    status.textContent = "This does not look like FortiOS output — paste the result of 'show full-configuration'."
    return
  }

  const started = performance.now()
  const result = audit(parseFortigate(text), FORTIGATE_RULES)
  const elapsed = Math.max(1, Math.round(performance.now() - started))

  renderAudit(results, result)
  status.textContent = `Analysed ${countLines(text).toLocaleString()} lines in ${elapsed} ms, entirely in this browser.`
}

const countLines = (text: string): number => text.split('\n').length
